import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import ReactJson from 'react-json-view';
import LogsStatusSelector from 'components/selectors/LogsStatusSelector';
import LogTypesSelector from 'components/selectors/LogTypesSelector';
import Table, { useTable } from 'common/components/table';
import BasicModal from 'common/components/modals/BasicModal';

const Logs = ({ topTabs }) => {
  const [activeRow, setRow] = useState({
    open: false,
    value: null
  });
  const table = useTable({
    label: 'log_reports',
    columns: [
      {
        header: 'Type',
        key: 'type',
        type: 'collection',
        component: LogTypesSelector,
        sort: true,
        width: 2
      },
      {
        header: 'Status Code',
        key: 'level',
        type: 'collection',
        component: LogsStatusSelector,
        sort: true,
        width: 2
      },
      {
        header: 'Context',
        key: 'context',
        type: 'string',
        sort: false,
        canFilter: false,
        width: 2
      }
    ],
    top: {}
  });

  return (
    <Row className="log-reports-table">
      <Col xs={12}>
        <Table
          loader
          bulk
          bulkActions={[]}
          topFiltersComponent={topTabs}
          rows={{
            context: data => (
              <div
                className="cursor-pointer"
                onClick={() => setRow({ open: true, value: data.context })}
              >
                Click for details
              </div>
            )
          }}
          {...table}
        />
      </Col>

      <BasicModal
        isOpen={activeRow.open}
        toggle={() => setRow(!activeRow.open)}
        header="Details"
        className="logs-modal-details"
        body={
          activeRow.value ? (
            <ReactJson
              enableClipboard={false}
              iconStyle="square"
              displayDataTypes={false}
              displayObjectSize={false}
              src={JSON.parse(activeRow.value)}
            />
          ) : null
        }
      />
    </Row>
  );
};

export default Logs;
